import json5 from 'json5'

export function loadData (endpoint) {
    var method = "GET"

    var fetchPromise = fetch(endpoint, {
        method, 
        credentials: 'same-origin'
    })

    var timeoutPromise = new Promise((resolve, reject) => {
        return setTimeout(() => reject(new Error(`Request timed out.`)), 20000)
    })

    return Promise.race([ fetchPromise, timeoutPromise ]).then(response => {
        return response.text()
        .then(text => {
            let data, parseError
            try { 
                data = json5.parse(text) 
            }
            catch (err) { 
                parseError = true 
            }

            if (!parseError && response.ok) {
                return data.data
            }

            if (response.ok && (parseError || text.match(/^\s*$/))) {
                throw new Error(`Server returned unexpected response.`)
            }

            throw new Error(`Problem communicating with server: ${response.status}, ${response.statusText}`)
        })
    })
}

export function loadHtml (endpoint ) {
    var method = "GET"

    var fetchPromise = fetch(endpoint, {
        method, 
        credentials: 'same-origin'
    })

    var timeoutPromise = new Promise((resolve, reject) => {
        return setTimeout(() => reject(new Error(`Request timed out.`)), 20000)
    })

    return Promise.race([ fetchPromise, timeoutPromise ]).then(response => {
        return response.text()
        .then(html => {
            if (response.ok) {
                return html 
            }

            throw new Error(`Problem communicating with server: ${response.status}, ${response.statusText}`)
        })
    })
}
